import ENDPOINTS from "../../constants/apiEndPoints";
import { axiosInstance } from "../axiosInstance";

export const handleGetShiftsService = async (params: {
  clientId?: string | string[];
  branchId?: string | string[];
}) => {
  const response = await axiosInstance.get(ENDPOINTS.GET_CREATE_SHIFT, {
    params,
  });
  return response?.data;
};
